import React from "react";
import {formatDate} from "helpers/data";
import ImgComment from "assets/images/svg/comments_s.svg";
import ImgAttachment from "assets/images/svg/attachment_s.svg";
import { Ticket } from "pages/tickets/ticket.service";

interface Props {
  ticket: Partial<Ticket>;
}

function TicketCard({ ticket }: Props) {
  let totalAtt = ticket?.totalAttachments ?? {};
  let totalMsg = ticket?.totalMessages ?? {};

  return (
    <div className="box-tacket">
      <div className="header-tacket">
        <div className="d-flex">
          <h2>{ticket?.title}</h2>
          <span className="span-tag">{ticket?.status}</span>
        </div>
        <span className="date">
          {ticket ? formatDate(ticket.createDate!) + " - " + formatDate(ticket.updateDate!) : ''}
        </span>
      </div>
      <p className="p-content">{ticket?.description}</p>
      <hr className="hr" />
      <div className="icon-attachment">
        {totalAtt > 0 && (
          <>
            {totalAtt}
            <span>
              <img src={ImgAttachment} alt="ImgComment" />
            </span>
          </>
        )}
        {totalMsg > 0 && (
          <>
            {totalMsg}
            <span>
              <img src={ImgComment} alt="ImgComment" />
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default TicketCard;
